import React from "react";
import { IsOkIcon } from "@ui/components/icons";

interface ApplicationStepProps extends React.SVGProps<SVGSVGElement> {
	isCurrentStep?: boolean;
	isMobile?: boolean;
	isValid?: boolean;
	isOk?: boolean;
}

export const ApplicationStep: React.FC<ApplicationStepProps> = ({ isValid, isOk, isCurrentStep, isMobile }) => {
	return <IsOkIcon isValid={isValid} isCurrentStep={isCurrentStep} isMobile={isMobile} isOk={isOk} />;
};
